"use client";

import React from "react";
import EditSection, { TextEditor, ListItemEditor } from "../../sections/shared/EditSection";
import { SectionContentProps } from "../../types";

export default function CorporateFeaturesEdit({
  content,
  onContentChange,
}: SectionContentProps) {
  const handleChange = (updated: Record<string, any>) => {
    onContentChange?.(updated);
  };

  const defaultFeatures = [
    { title: "Security First", description: "Bank-grade encryption and strict compliance controls.", icon: "security" },
    { title: "Global Scale", description: "Infrastructure distributed across 20+ regions worldwide.", icon: "globe" },
    { title: "24/7 Support", description: "Dedicated customer success managers for your team.", icon: "support" }
  ];

  return (
    <EditSection
      content={content}
      onContentChange={handleChange}
      contentFields={
        <div className="space-y-4">
          <div className="p-3 bg-gray-50 rounded-lg space-y-3">
            <h4 className="text-xs font-semibold text-gray-700">Section Headers</h4>
            <TextEditor
              label="Title"
              value={content.title}
              onChange={(v) => handleChange({ ...content, title: v })}
              placeholder="Enterprise Solutions"
            />
          </div>

          <div className="p-3 bg-gray-50 rounded-lg space-y-3">
            <h4 className="text-xs font-semibold text-gray-700">Features List</h4>
            <ListItemEditor
              label="Features"
              items={content.features || defaultFeatures}
              itemSchema={[
                { key: "title", label: "Feature Title", type: "text" },
                { key: "description", label: "Description", type: "text" },
                { key: "icon", label: "Icon Name (security, globe, support)", type: "text" },
              ]}
              onChange={(items) => handleChange({ ...content, features: items })}
              addItemText="Add Feature"
            />
          </div>
        </div>
      }
    />
  );
}
